module.exports = __webpack_public_path__ + "static/img/hs_bang.a39cad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/hs_bang.png
// module id = RmPN
// module chunks = 1